// Generated by GitHub Copilot
import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/settings/')({
  component: RouteComponent,
})

/** `/settings` has no page of its own yet — land on the user's account page. */
function RouteComponent() {
  return <Navigate to="/settings/user" />
}
